/*
 * @Descripttion:
 * @version:
 * @Author: loong
 * @Date: 2022-09-08 15:30:36
 * @LastEditors: loong
 * @LastEditTime: 2022-09-08 16:44:09
 */
// 通用顶部条组件
const topbar = () => import ("../../layout/topbar");
// 通用主体顶部组件
const AppHeader_Nav = () => import ("../../layout/AppHeader_Navs");
// 通用主体头部组件
const AppHeader_main = () => import ("../../layout/AppHeader_main");
// 通用底部组件
const AppFooter = () => import ("../../layout/AppFooter");
// 当前路由组件
const login = () => import('../../views/loginRegistration/login.vue');
const register = () => import('../../views/loginRegistration/register.vue');
const Error = () => import('../../components/Error.vue');
export default [{
  path: "/login",
  name: "login",
  components: {
    default: login,
  },
  meta: {
    requireAuth: false // 需要验证登录状态
  },
  props: {},
},
  {
    path: "/register",
    name: "register",
    components: {
      default: register,
    },
    meta: {
      requireAuth: false // 需要验证登录状态
    },
    props: {},
  },
  {
    path: "/error",
    name: "Error",
    components: {
      default: Error,
    },
    meta: {
      requireAuth: false // 需要验证登录状态
    },
    props: {},
  },
]
